import { useState, useEffect } from 'react';
import { endpoints } from './api';

export function useTelegramSDK() {
  const [isInitialized, setIsInitialized] = useState(false);
  const [error, setError] = useState(null);
  const [user, setUser] = useState(null);

  useEffect(() => {
    try {
      const WebApp = window.Telegram?.WebApp;

      console.log('=== Telegram WebApp Debug Info ===');
      console.log('window.Telegram:', window.Telegram);
      console.log('window.Telegram.WebApp:', WebApp);
      console.log('initData:', WebApp?.initData);
      console.log('initDataUnsafe:', WebApp?.initDataUnsafe);
      console.log('platform:', WebApp?.platform);
      console.log('version:', WebApp?.version);
      console.log('===============================');

      // Проверяем, доступен ли Telegram WebApp и есть ли данные пользователя
      const telegramUser = WebApp?.initDataUnsafe?.user;
      if (!WebApp || !telegramUser) {
        console.warn('Не запущено в Telegram WebView или нет пользователя');
        setError('Это приложение должно быть открыто внутри Telegram');
        return;
      }

      setUser(telegramUser);

      // Устанавливаем тему Telegram
      const scheme = WebApp.colorScheme || 'light';
      document.documentElement.setAttribute('data-theme', scheme);

      setIsInitialized(true);
    } catch (error) {
      console.error('Ошибка инициализации Telegram WebApp:', error);
      setError('Ошибка инициализации Telegram WebApp');
    }
  }, []);

  const getUserFullName = () => {
    if (!user) return '';
    return `${user.first_name}${user.last_name ? ' ' + user.last_name : ''}`;
  };

  const showPopup = ({ title, message, buttons = [{ type: 'ok' }] }) => {
    const WebApp = window.Telegram?.WebApp;
    WebApp?.showPopup?.({ title, message, buttons });
  };

  const closeApp = (delay = 0) => {
    const WebApp = window.Telegram?.WebApp;
    if (WebApp?.close) {
      delay > 0 ? setTimeout(() => WebApp.close(), delay) : WebApp.close();
    }
  };

  const submitForm = async (formData, category) => {
    try {
      const WebApp = window.Telegram?.WebApp;
      const initData = WebApp?.initData;

      console.log('=== Form Submission Debug ===');
      console.log('WebApp:', WebApp);
      console.log('initData:', initData);
      console.log('initData type:', typeof initData);
      console.log('initData length:', initData?.length);
      console.log('==========================');

      if (!initData) {
        throw new Error('Не удалось получить данные Telegram');
      }

      const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://sittersandtutors.ru';
      const endpoint = endpoints[category];
      if (!endpoint) throw new Error('Неизвестная категория формы');

      const response = await fetch(`${API_BASE_URL}${endpoint}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Telegram-Init-Data': initData,
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (!response.ok) {
        console.error('Ошибка сервера:', result);
        throw new Error(JSON.stringify(result));
      }

      return true;
    } catch (error) {
      console.error('Ошибка при отправке формы:', error);
      throw error;
    }
  };

  return {
    isInitialized,
    error,
    user,
    getUserFullName,
    showPopup,
    closeApp,
    submitForm
  };
} 